module.exports = __webpack_public_path__ + "static/img/pic_jifeiyc.001c81b0.png";